/**
 * The `?replace=<slot>` deep link (the Website hub's Logos card): the slot to open the upload for, when it is one of
 * `slots` (the brand's own logos), else null; and the search string without the parameter, which the page writes
 * back (history replace) whatever the value was, so a reload never reopens the upload. `''` when nothing remains.
 */
export const replaceSlotParam = (search: string, slots: readonly string[]): { slot: string | null; search: string } => {
  const params = new URLSearchParams(search);
  const value = params.get('replace');
  if (value === null) return { slot: null, search };
  params.delete('replace');
  const rest = params.toString();
  return { slot: slots.includes(value) ? value : null, search: rest ? `?${rest}` : '' };
};
